var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "content-wrapper" }, [
          _c("div", { staticClass: "container-wrapper center" }, [
            _c(
              "div",
              [
                _c("GoBack"),
                _vm._v(" "),
                _c("h3", { staticClass: "d-inline heading" }, [
                  _vm._v(_vm._s(_vm.tasklist_name))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "heading-seperator" }),
            _vm._v(" "),
            _vm.students.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "col-md-6 col-sm-9 col-12 mx-auto",
                    staticStyle: { "font-size": "18px" }
                  },
                  [
                    _c("label", { staticClass: "text-align-center" }, [
                      _vm._v("Students: ")
                    ]),
                    _vm._v(" "),
                    _c("b-form-select", {
                      staticClass: "mb-3 col-md-12",
                      staticStyle: { "margin-bottom": "0px !important" },
                      attrs: { options: _vm.students },
                      on: {
                        change: function($event) {
                          return _vm.updateStudentTasklistAction()
                        }
                      },
                      model: {
                        value: _vm.student_id,
                        callback: function($$v) {
                          _vm.student_id = $$v
                        },
                        expression: "student_id"
                      }
                    }),
                    _vm._v(" "),
                    _c("hr", { staticStyle: { width: "100%" } })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.page_loading,
                    expression: "page_loading"
                  }
                ],
                staticClass: "loading_show"
              },
              [_c("div", { staticClass: "spinner-border text-danger" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.no_students,
                    expression: "no_students"
                  }
                ],
                staticClass: "row"
              },
              [_vm._m(0)]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-md-12 counter_subtask-list",
                attrs: { id: "tasks" }
              },
              [
                _vm._l(_vm.subtasks, function(subtask, stindex) {
                  return _c("div", [
                    _c(
                      "div",
                      { staticClass: "subtask-wrapper" },
                      [
                        _c(
                          "h4",
                          { staticClass: "panel-title" },
                          [
                            _c(
                              "b-link",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: "collapse-" + subtask.id,
                                    expression: "'collapse-' + subtask.id"
                                  }
                                ]
                              },
                              [
                                _c("span", {
                                  staticClass: "counter_subtask-list__counter"
                                }),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(subtask.name) +
                                    "\n                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          {
                            staticClass: "mt-2 subtask-wrapper",
                            attrs: { id: "collapse-" + subtask.id }
                          },
                          [
                            _c("b-card", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 override-padding counter_heading-list"
                                },
                                _vm._l(subtask.headings, function(
                                  heading,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    [
                                      _c(
                                        "b-link",
                                        {
                                          directives: [
                                            {
                                              name: "b-toggle",
                                              rawName: "v-b-toggle",
                                              value:
                                                "collapse-" +
                                                subtask.id +
                                                "-" +
                                                heading.id,
                                              expression:
                                                "'collapse-' + subtask.id + '-' + heading.id"
                                            }
                                          ],
                                          staticClass: "sub-heading",
                                          attrs: { size: "sm" }
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "counter_heading-list__counter"
                                          }),
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(heading.name) +
                                              "\n                        "
                                          ),
                                          _c("i", {
                                            staticClass: "fa fa-angle-down",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-collapse",
                                        {
                                          staticClass: "mt-2 task-wrapper",
                                          attrs: {
                                            id:
                                              "collapse-" +
                                              subtask.id +
                                              "-" +
                                              heading.id
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 override-padding counter_task-list"
                                            },
                                            _vm._l(heading.tasks, function(
                                              task
                                            ) {
                                              return _c(
                                                "div",
                                                [
                                                  _c(
                                                    "b-card",
                                                    {
                                                      staticClass:
                                                        "float-left d-none d-md-block d-lg-block modal-task",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.openHistoryModal(
                                                            "" +
                                                              _vm.student_id +
                                                              "",
                                                            "" + task.id + ""
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "task-title"
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "counter_task-list__counter"
                                                          }),
                                                          _vm._v(
                                                            "\n                                " +
                                                              _vm._s(
                                                                task.description
                                                              ) +
                                                              "\n                              "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      task.instructor_score
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "other-account-task-score",
                                                              attrs: {
                                                                id:
                                                                  "popover-target-" +
                                                                  subtask.id +
                                                                  "-" +
                                                                  task.id
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                " +
                                                                  _vm._s(
                                                                    task.instructor_score
                                                                  ) +
                                                                  "\n                                "
                                                              ),
                                                              _c(
                                                                "b-popover",
                                                                {
                                                                  attrs: {
                                                                    target:
                                                                      "popover-target-" +
                                                                      subtask.id +
                                                                      "-" +
                                                                      task.id,
                                                                    triggers:
                                                                      "hover",
                                                                    placement:
                                                                      "top"
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "title",
                                                                        fn: function() {
                                                                          return [
                                                                            _vm._v(
                                                                              "Mentor Comments"
                                                                            )
                                                                          ]
                                                                        },
                                                                        proxy: true
                                                                      }
                                                                    ]
                                                                  )
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                  " +
                                                                      _vm._s(
                                                                        task.instructor_comment
                                                                      ) +
                                                                      "\n                                "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      task.score
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "task-score",
                                                              attrs: {
                                                                "data-toggle":
                                                                  "tooltip",
                                                                title: "Score"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                " +
                                                                  _vm._s(
                                                                    task.score
                                                                  ) +
                                                                  "\n                              "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-card",
                                                    {
                                                      staticClass:
                                                        "float-left  d-block d-sm-block d-md-none",
                                                      attrs: { id: task.id }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "task-title"
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "counter_task-list__counter"
                                                          }),
                                                          _vm._v(
                                                            "\n                                " +
                                                              _vm._s(
                                                                task.description
                                                              ) +
                                                              "\n                              "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      task.instructor_score
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "other-account-task-score",
                                                              attrs: {
                                                                id:
                                                                  "popover-target-mob-" +
                                                                  subtask.id +
                                                                  "-" +
                                                                  task.id
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                " +
                                                                  _vm._s(
                                                                    task.instructor_score
                                                                  ) +
                                                                  "\n                                "
                                                              ),
                                                              _c(
                                                                "b-popover",
                                                                {
                                                                  attrs: {
                                                                    target:
                                                                      "popover-target-mob-" +
                                                                      subtask.id +
                                                                      "-" +
                                                                      task.id,
                                                                    triggers:
                                                                      "hover",
                                                                    placement:
                                                                      "top"
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "title",
                                                                        fn: function() {
                                                                          return [
                                                                            _vm._v(
                                                                              "Mentor Comments"
                                                                            )
                                                                          ]
                                                                        },
                                                                        proxy: true
                                                                      }
                                                                    ]
                                                                  )
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                  " +
                                                                      _vm._s(
                                                                        task.instructor_comment
                                                                      ) +
                                                                      "\n                                "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      task.score
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "task-score"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                " +
                                                                  _vm._s(
                                                                    task.score
                                                                  ) +
                                                                  "\n                              "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "comment-icon-wrapper"
                                                        },
                                                        [
                                                          _c(
                                                            "router-link",
                                                            {
                                                              attrs: {
                                                                to:
                                                                  "/student-add-task-assessment/" +
                                                                  _vm.student_id +
                                                                  "/" +
                                                                  _vm.group_id +
                                                                  "/" +
                                                                  task.id +
                                                                  "/" +
                                                                  _vm.tasklist_id +
                                                                  "@" +
                                                                  heading.id +
                                                                  "@" +
                                                                  subtask.id +
                                                                  ""
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-comment"
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "view-comment"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Add Comments"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticStyle: { clear: "both" }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 override-padding counter_task-list"
                                },
                                _vm._l(subtask.tasks, function(
                                  substasklisttask
                                ) {
                                  return _c(
                                    "div",
                                    { staticClass: "task-wrapper" },
                                    [
                                      _c(
                                        "b-card",
                                        {
                                          staticClass:
                                            "float-left d-none d-md-block modal-task",
                                          on: {
                                            click: function($event) {
                                              return _vm.openHistoryModal(
                                                "" + _vm.student_id + "",
                                                "" + substasklisttask.id + ""
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "task-title" },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "counter_task-list__counter"
                                              }),
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    substasklisttask.description
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          substasklisttask.instructor_score
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "other-account-task-score",
                                                  attrs: {
                                                    id:
                                                      "popover-target-" +
                                                      substasklisttask.id
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        substasklisttask.instructor_score
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                  _c(
                                                    "b-popover",
                                                    {
                                                      attrs: {
                                                        target:
                                                          "popover-target-" +
                                                          substasklisttask.id,
                                                        triggers: "hover",
                                                        placement: "top"
                                                      },
                                                      scopedSlots: _vm._u([
                                                        {
                                                          key: "title",
                                                          fn: function() {
                                                            return [
                                                              _vm._v(
                                                                "Mentor Comments"
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ])
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            " +
                                                          _vm._s(
                                                            substasklisttask.instructor_comment
                                                          ) +
                                                          "\n                          "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          substasklisttask.score
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "task-score",
                                                  attrs: {
                                                    "data-toggle": "tooltip",
                                                    title: "Score"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        substasklisttask.score
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-card",
                                        {
                                          staticClass:
                                            "float-left d-block d-sm-block d-md-none",
                                          attrs: { id: substasklisttask.id }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "task-title" },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "counter_task-list__counter"
                                              }),
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    substasklisttask.description
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          substasklisttask.instructor_score
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "other-account-task-score",
                                                  attrs: {
                                                    id:
                                                      "popover-target-mob-" +
                                                      substasklisttask.id
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        substasklisttask.instructor_score
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                  _c(
                                                    "b-popover",
                                                    {
                                                      attrs: {
                                                        target:
                                                          "popover-target-mob-" +
                                                          substasklisttask.id,
                                                        triggers: "hover",
                                                        placement: "top"
                                                      },
                                                      scopedSlots: _vm._u([
                                                        {
                                                          key: "title",
                                                          fn: function() {
                                                            return [
                                                              _vm._v(
                                                                "Mentor Comments"
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ])
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            " +
                                                          _vm._s(
                                                            substasklisttask.instructor_comment
                                                          ) +
                                                          "\n                          "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          substasklisttask.score
                                            ? _c(
                                                "div",
                                                { staticClass: "task-score" },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        substasklisttask.score
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "comment-icon-wrapper"
                                            },
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to:
                                                      "/student-add-task-assessment/" +
                                                      _vm.student_id +
                                                      "/" +
                                                      _vm.group_id +
                                                      "/" +
                                                      substasklisttask.id +
                                                      "/" +
                                                      _vm.tasklist_id +
                                                      "@" +
                                                      "null" +
                                                      "@" +
                                                      subtask.id +
                                                      ""
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-comment"
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "view-comment"
                                                    },
                                                    [_vm._v("Add Comments")]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("div", { staticStyle: { clear: "both" } })
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                }),
                _vm._v(" "),
                _c(
                  "custommodal",
                  {
                    attrs: { isModalVisible: _vm.isModalVisible },
                    on: {
                      close: function($event) {
                        _vm.isModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v(
                            "\n                  Loading...\n             "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [_vm._v(_vm._s(_vm.history_title))]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                      _c(
                        "div",
                        { staticClass: "comment_form" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.hmentee_id,
                                expression: "hmentee_id"
                              }
                            ],
                            attrs: {
                              type: "hidden",
                              name: "hmentee_id",
                              id: "hmentee_id"
                            },
                            domProps: { value: _vm.hmentee_id },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.hmentee_id = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.htask_id,
                                expression: "htask_id"
                              }
                            ],
                            attrs: {
                              type: "hidden",
                              name: "htask_id",
                              id: "htask_id"
                            },
                            domProps: { value: _vm.htask_id },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.htask_id = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "label" }, [
                            _vm._v("Score:")
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            staticClass: "input-text",
                            attrs: { options: _vm.score_options },
                            model: {
                              value: _vm.score_selected,
                              callback: function($$v) {
                                _vm.score_selected = $$v
                              },
                              expression: "score_selected"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-20",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "label" }, [
                            _vm._v("Comments:")
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.comments,
                                expression: "comments"
                              }
                            ],
                            staticClass:
                              "textarea col-xs-12 col-md-12 col-lg-12 input-height-25",
                            attrs: {
                              placeholder: "Add your comments",
                              maxlength: "1000"
                            },
                            domProps: { value: _vm.comments },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.comments = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-20",
                            staticStyle: { clear: "both" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "submit margin-bottom-15" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "submit_button btn btn-info btn-md",
                                  attrs: { type: "submit" },
                                  on: { click: _vm.onSubmit }
                                },
                                [_vm._v("Submit")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "margin-left-20 submit_button btn btn-grey btn-md",
                                  attrs: { type: "submit" },
                                  on: { click: _vm.closeModal }
                                },
                                [_vm._v("Cancel")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "history-table-wrapper" }, [
                        _c(
                          "table",
                          { staticClass: "generic-list" },
                          [
                            _c("thead", [
                              _c("tr", [
                                _c("th", { staticClass: "date" }, [
                                  _vm._v("DATE")
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "score" }, [
                                  _vm._v("SCORE")
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "comment" }, [
                                  _vm._v("COMMENT")
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "postedby" }, [
                                  _vm._v("COMMENTED BY")
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.assessment_loading,
                                    expression: "assessment_loading"
                                  }
                                ],
                                staticClass: "loading_show"
                              },
                              [
                                _c("div", {
                                  staticClass: "spinner-border text-danger"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.history_comment, function(history) {
                              return [
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDate")(history.createdAt)
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(history.score))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(history.comment))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(history.mentor_name))
                                  ])
                                ])
                              ]
                            }),
                            _vm._v(" "),
                            _vm.history_comment.length == 0 &&
                            _vm.assessment_loading == false
                              ? [
                                  _c("tr", [
                                    _c("td", { attrs: { colspan: "4" } }, [
                                      _vm._v("No Assessments Found.")
                                    ])
                                  ])
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ])
                    ])
                  ]
                )
              ],
              2
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mx-auto" }, [
      _c("h6", { staticClass: "text-align-center" }, [
        _vm._v("No Students assigned for this tasklist.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a91a7fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a91a7fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/instructor/students_tasks_details.vue
// module id = null
// module chunks = 